import { render, staticRenderFns } from "./card-note.vue?vue&type=template&id=0c6316a6&scoped=true"
import script from "./card-note.vue?vue&type=script&lang=js"
export * from "./card-note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6316a6",
  null
  
)

export default component.exports